import React from "react";
import { Divisor } from "../../../bci/styles";

export const AraucariaContact: React.FC = () => {
    return (
        <div>
            <Divisor />
            <h4>INFORMAÇÕES GERAIS</h4>
            <Divisor />
            <div>
                <p>
                    Solicitações de requerimentos e modelos para aprovação de
                    projetos arquitetônicos podem ser solicitados através do
                    e-mail du.smur@araucaria.pr.gov.br
                </p>

                <p>
                    Plantão Técnico (das 13:00 às 16:00)
                    <br />
                    (41) 3614-1443 (fixo e whats app)
                    <br />
                    email: du.smur@araucaria.pr.gov.br
                    <br />
                    Paço Municipal, 1º andar
                </p>
            </div>
            <Divisor />
        </div>
    );
};
